var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":"https://i.niupic.com/images/2022/11/02/aaa1.png"},on:{"click":_vm.toGit}})
}
var staticRenderFns = []

export { render, staticRenderFns }